module.exports = __webpack_public_path__ + "img/Ovidius.09ef6946.jpg";